import * as React from 'react';
import { IPriceString } from '../../helpers/priceHelpers';
import { __ } from '../../helpers/TranslationService';
export interface IPerPersonPriceTable {
    priceLabel?: string;
    dualCurrencyString?: string;
}

export const PerPersonPriceTable = (props: IPerPersonPriceTable) => {
    const { priceLabel, dualCurrencyString } = props;
    const compName = 'per-person-price-table';
    return (
        <>
            <PriceFormat
                className={`${compName}__price`}
                price={
                    dualCurrencyString !== null && dualCurrencyString !== ''
                        ? dualCurrencyString
                        : priceLabel
                }
            />
            {dualCurrencyString !== null && dualCurrencyString !== '' && (
                <PriceFormat className={`${compName}__dual-corrency`} price={priceLabel} />
            )}
        </>
    );
};

const PriceFormat = ({ price, className }: { price: string; className?: string }) => (
    <div className={`col-xs-12 noPadding text-right ${className}`}>{price}</div>
);
